const setSelectedSearchBy = (state, payload) => {
  state.search.searchBy = payload
}
const setTotalTemplates = (state, payload) => {
  state.search.totalTemplates = payload
}
const setTotalPresentations = (state, payload) => {
  state.search.totalPresentations = payload
}

export default {
  setSelectedSearchBy,
  setTotalTemplates,
  setTotalPresentations,
}
